import React from 'react';
import { arrayOf, shape, string, func } from 'prop-types';
import { format, dateFormats } from 'helpers/date';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import styles from './styles/index.scss';

export default class ClusterTable extends React.Component {
  static propTypes = {
    data: arrayOf(
      shape({
        name: string,
        id: string,
        createdDateTime: string,
        status: string
      })
    ),
    onDeleteCluster: func
  };

  state = {
    page: 0,
    rowsPerPage: 10
  };

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage
    });
  };

  handleChangeRowsPerPage = event => {
    const newRowsPerPage = parseInt(event.target.value, 10);

    this.setState({
      rowsPerPage: newRowsPerPage,
      page: 0
    });
  };

  handleDeleteCluster = id => () => {
    const { onDeleteCluster } = this.props;

    onDeleteCluster(id);
  };

  render() {
    const { data } = this.props;
    const { page, rowsPerPage } = this.state;

    return (
      <Table className={styles.table}>
        <TableHead>
          <TableRow>
            <TableCell>Cluster Name</TableCell>
            <TableCell>Cluster ID</TableCell>
            <TableCell>Cluster Create Time</TableCell>
            <TableCell>Cluster Status</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : data).map(cluster =>
            <TableRow key={cluster.id}>
              <TableCell>
                {cluster.name}
              </TableCell>
              <TableCell>
                {cluster.id}
              </TableCell>
              <TableCell>
                {format(cluster.createdDateTime, dateFormats.full)}
              </TableCell>
              <TableCell>
                {cluster.status}
              </TableCell>
              <TableCell>
                <IconButton onClick={this.handleDeleteCluster(cluster.id)}>
                  <HighlightOffIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/aiware/components/ClusterTable.js